<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="overflow-hidden rounded-2xl font-poppins">
    <ul role="list" class="divide-y divide-gray-200 list-none">
      <li v-for="action in actions" :key="action.name">
        <div class="block">
          <div class="flex items-center">
            <div class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between">
              <div class="truncate">
                <div class="flex text-sm items-center">
                  <CheckIcon class="flex-shrink-0 w-6 h-6 text-brand-secondary-accent" aria-hidden="true" />
                  <p class="font-poppins text-lg ml-1 text-black py-0 my-0">{{ action.discountDescription }}</p>
                </div>
              </div>
              <div class="mt-1 flex-shrink-0 ">
                <div class="flex overflow-hidden -space-x-1">
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang='ts'>
import { defineProps, computed } from 'vue';
import { CheckIcon } from '@heroicons/vue/outline';
import { Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';

const props = defineProps<{
  suggestedPromotion: Promotion,
}>();

const actions = computed(() => {
  return props.suggestedPromotion.actions.filter((action) => {
    return action.discountDescription !== '';
  });
});

</script>
